import React, { useEffect, useState, useCallback } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ServiceManager } from '@jutro/legacy/services';
import { UserService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { MLNotificationBlockUtil,  MLProducerUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import { platformMessages } from 'ml-components-platform-react';
import _ from 'lodash';
import metadata from './Preferences.metadata.json5';
import styles from './Preferences.module.scss';
import preferencemessages from'./Preferences.messages';


function Preferences() {
    const { authHeader } = useAuthentication();
    const { getProducerCodeDisplayName } = MLProducerUtil();
    const translator = useTranslator();
    const {
        addSuccessAlert,
        addErrorAlert,
        clearAlerts
    } = MLNotificationBlockUtil();
    const {
        showProgressDialog
    } = MLModalService();
    const localeService = ServiceManager.getService('locale-service');

    const [currentUser, updateCurrentUser] = useState(undefined);
    const [selectedGroup, updateSelectedGroup] = useState('');
    const [selectedProducerCode, updateSelectedProducerCode] = useState('');
    const [groupList, updateGroupList ] = useState({});
    const [producerList, updateProducerList] = useState({});

    const retrieveProducerCodeDisplayName = useCallback((producer) => getProducerCodeDisplayName(producer), [getProducerCodeDisplayName]);

    useEffect(() => {
        UserService.getCurrentUser(authHeader, true).then((user) => {
            updateCurrentUser(user);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getGroupAvailableValues = useCallback(() => {
        const sortedGroupList = _.sortBy(groupList, 'groupID');
        
        return sortedGroupList.map((group) => ({
                code: group.groupID,
                name: group.groupName
            }));
    }, [ groupList ]);

    const getProducerAvailableValues = useCallback(() => {
        const sortedProducerList = _.sortBy(producerList, 'producerContactLastName_ML');
        
        return sortedProducerList.map((producer) => ({
                code: producer.code,
                name: retrieveProducerCodeDisplayName(producer)
            }));
    }, [retrieveProducerCodeDisplayName, producerList]);

    // Set list of available groups based on the user
    const setAvailableGroups = useCallback(() => {
        const selectedGroupPromise = UserService.getUserAvailableGroups(authHeader);

        selectedGroupPromise.then((selectedGroups) => {
            updateGroupList(selectedGroups);
        })
    }, [authHeader]);

    // Set list of available producer codes based on the group selected
    const setAvailableProducerCodes = useCallback((initialAffiliatedGroupML = undefined) => {
        const selectedGroupId = _.get(initialAffiliatedGroupML, 'publicID') || _.get(selectedGroup, 'publicID');

        if (selectedGroupId) {
            const selectedGroupPromise = UserService.getProducerCodesForGroup(selectedGroupId, authHeader);

            selectedGroupPromise.then((selectedProducerCodes) => {
                updateProducerList(selectedProducerCodes);
            });
        }
    }, [authHeader, selectedGroup]);

    // Set list of available producer codes based on the group selected
    const updateAvailableProducerCodes = useCallback((groupID) => {
        let updatedGroup;

        groupList.forEach((group) => {
            if (group.groupID === groupID) {
                updatedGroup = group
            }
        })

        setAvailableProducerCodes(updatedGroup)
        updateSelectedProducerCode('')
    }, [groupList, setAvailableProducerCodes]);

    useEffect(() => {
        if (!_.isUndefined(currentUser) && !_.isUndefined(currentUser.primaryProducerCode_ML) && !_.isUndefined(currentUser.affiliatedGroup_ML)) {
            updateSelectedProducerCode(currentUser.primaryProducerCode_ML.code);
            updateSelectedGroup(currentUser.affiliatedGroup_ML.groupID);
            setAvailableProducerCodes(currentUser.affiliatedGroup_ML);
            setAvailableGroups();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser])

    const onSavePrimaryProducerCodeClick = () => {
        clearAlerts();

        const producerCodeOverridePromise = UserService.setPrimaryProducerCodeOverride(selectedProducerCode, authHeader);

        showProgressDialog(platformMessages.loading, producerCodeOverridePromise);
        producerCodeOverridePromise.then((response) => {
            
            if (_.isEmpty(response)) {
                addErrorAlert(translator(preferencemessages.preferencesFail), 'fail');
            } else {
                addSuccessAlert(translator(preferencemessages.preferencesSuccess), 'success');
                UserService.getCurrentUser(authHeader, true, true).then((user) => {
                    updateCurrentUser(user);
                });
            }
        });
    };

    const overrideProps = {
        globalizationChooserField: {
            onLanguageValueChange: localeService.saveLanguage,
            languageValue: localeService.getStoredLanguage(),
            availableLanguageValues: localeService.getAvailableLanguages(),
        },
        groupField: {
            availableValues: getGroupAvailableValues(),
            path: 'selectedGroup',
            value: selectedGroup,
            onValueChange: (value) => {
                updateSelectedGroup(value);
                updateAvailableProducerCodes(value);
            }
        },
        producerField: {
            availableValues: getProducerAvailableValues(),
            path: 'selectedProducerCode',
            value: selectedProducerCode,
            onValueChange: (value) => {
                updateSelectedProducerCode(value);
            }
        },
        savePrimaryProducerCodeButton: {
            onClick: onSavePrimaryProducerCodeClick,
            disabled: (_.isEmpty(selectedGroup) || _.isEmpty(selectedProducerCode))
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            MLAlertGroupComponent
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

export default Preferences;
